import React from 'react';
import { FormProvider } from 'context/FormContext';
import StepContainer from 'components/layout/StepContainer';
import Header from 'components/layout/Header';
import StepperControl from './StepperControl';

function PageLayout(){
    return (
        <div className="e3dc-conf">
            <FormProvider>
                {process.env.NODE_ENV === 'development' && <Header />}
                <StepContainer />
                <StepperControl />
            </FormProvider>
        </div>
    )
}

export default PageLayout;